import ChangePassword from './change-password-view'
export default ChangePassword
